import React from 'react'
import { cn } from './cn'

export function Spinner({ className, size = 'md' }) {
  const sizeClass = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-10 w-10' : 'h-6 w-6'
  return (
    <div
      className={cn('animate-spin rounded-full border-2 border-primary-200 border-t-primary-600 dark:border-secondary-600 dark:border-t-primary-400', sizeClass, className)}
      role="status"
      aria-label="Loading"
    />
  )
}
